import * as actions from "../common/actions";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { initialAppState } from "../common/reducers/appState";
import SOD from "../components/SOD/SOD";

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    resetState: () => {
      dispatch(actions.resetState(initialAppState.SOD));
    },
  };
}

export default connect(null, mapDispatchToProps)(SOD);
